import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import { numeralFormat } from 'src/utils/misc';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { DangerTooltip } from '../comps';

interface RiskAvoidanceV2Props {
  value: DashboardQuery['dashboard']['riskAvoidance'];
  state: AssessmentState;
  noIncidentsComponent?: React.ReactNode;
}

export const RiskAvoidanceV2: React.FC<RiskAvoidanceV2Props> = ({ value, state, noIncidentsComponent }) => {
  return (
    <BaseCard>
      <span className="c-title">Risk Avoidance</span>

      <span className="description">
        Security programme has avoided{' '}
        <b>
          {value?.nearMisses} near miss{value?.nearMisses === 1 ? '' : 'es'}
        </b>{' '}
        in the last {value?.days} days, which could have resulted in losses of:
      </span>
      <div style={{ flex: 1 }} />

      {state === 'NO_SCENARIOS' ? (
        <DangerTooltip state={state} />
      ) : (
        <>
          {noIncidentsComponent ? (
            noIncidentsComponent
          ) : (
            <div>
              {value?.nearMisses ? (
                <Poppins weight={600} color="gp1" px={26}>
                  {numeralFormat(value?.estimatedLossLower)} - {numeralFormat(value?.estimatedLossUpper)}
                </Poppins>
              ) : (
                <Poppins weight={600} color="gp1" px={26}>
                  N/A
                </Poppins>
              )}
            </div>
          )}
        </>
      )}
    </BaseCard>
  );
};
